<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 569.1 115.7">
    <path
      class="cls-1"
      d="M122.5,50.6h-48.6L102.7.7h-16.9l-24.6,42.6L36.6.7h-16.8l28.8,49.9H0v14.6h48.6l-28.8,49.9h16.8l24.6-42.6,24.6,42.6h16.8l-28.8-49.9h48.6v-14.6h.1ZM73.1,64.8l-11.9,6.8-11.9-6.8v-13.7l11.9-6.8,11.9,6.8v13.7Z"
    />
    <path
      class="cls-2"
      d="M220.6.7l-26,101.3h-8.8L159.8.7h-15l29.7,114.4h31.4L235.6.7h-15ZM311.3,73.7l11-10.9V13.8l-13.1-13.1h-65.4v114.4h14.7v-39.2h38.4l18.5,39.2h15.9l-19.9-41.4h-.1ZM307.5,62.8h-49V13.8h49v49ZM391.4,13.1V0l-27.8,1.3-27.8-1.3v13.1l20.4.8v87.9l-20.4.8v13.1l27.8-1.3,27.8,1.3v-13.1l-20.4-.8V13.9l20.4-.8ZM473.4,13.8V.7h-72.4v114.4h14.7v-39.2h54.4v-13.1h-54.4V13.7h57.7v.1Z"
    />
    <path
      class="cls-2"
      d="M554,.7l-15.95,62.1h-28.91L493.2.7h-15l15.3,58.8,4.26,16.4h18.54v39.2h14.7v-39.2s18.54,0,18.54,0l4.26-16.4,15.3-58.8h-15.1Z"
    />
  </svg>
</template>

<style scoped>
.cls-1 {
  fill-rule: evenodd;
  fill: currentColor;
}
.cls-2 {
  fill: currentColor;
}
</style>
